import React, { useState, useEffect } from "react";
import {
  HeaderWrapper,
  HeaderImageWrapper,
  HeaderImage,
  NavigationWrapper,
  NavLink,
  DownloadResumeButton,
  MobileMenuButton,
  MobileMenu,
  MobileNavLink,
  MobileDownloadButton,
  HeaderContent,
} from "../../pages/subcomponents";
import manoj from "../../assesets/brand.png";
import resume from "../../assesets/resume/manojkumar_s.pdf";
import { trackResumeDownload } from "../../utils/analytics";

const Header = (): React.ReactElement => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "about", "experience", "projects", "contact"];
      const scrollPosition = window.scrollY + 50;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (
            scrollPosition >= offsetTop &&
            scrollPosition < offsetTop + offsetHeight
          ) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDownloadResume = () => {
    trackResumeDownload();
    const link = document.createElement("a");
    link.href = resume;
    link.download = "ManojKumar_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false); // Close mobile menu after navigation
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <HeaderWrapper>
        <HeaderContent>
          <HeaderImageWrapper>
            <HeaderImage
              src={manoj}
              alt="Manoj Kumar - Full Stack Developer"
              loading="eager"
              onClick={() => {
                scrollToSection("home");
              }}
              aria-label="Manoj Kumar Portfolio Logo"
            />
          </HeaderImageWrapper>

          <NavigationWrapper role="navigation" aria-label="Main navigation">
            <NavLink
              href="#home"
              isActive={activeSection === "home"}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("home");
              }}
              aria-label="Navigate to Home section"
              tabIndex={0}
            >
              Home
            </NavLink>
            <NavLink
              href="#about"
              isActive={activeSection === "about"}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("about");
              }}
              aria-label="Navigate to About section"
              tabIndex={0}
            >
              About Me
            </NavLink>
            <NavLink
              href="#experience"
              isActive={activeSection === "experience"}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("experience");
              }}
              aria-label="Navigate to Experience section"
              tabIndex={0}
            >
              Experience
            </NavLink>
            <NavLink
              href="#projects"
              isActive={activeSection === "projects"}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("projects");
              }}
              aria-label="Navigate to Projects section"
              tabIndex={0}
            >
              Projects
            </NavLink>
            <NavLink
              href="#contact"
              isActive={activeSection === "contact"}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("contact");
              }}
              aria-label="Navigate to Contact section"
              tabIndex={0}
            >
              Contact
            </NavLink>
            <DownloadResumeButton
              onClick={handleDownloadResume}
              aria-label="Download Manoj Kumar's resume"
              tabIndex={0}
            >
              Download Resume
            </DownloadResumeButton>
          </NavigationWrapper>

          <MobileMenuButton
            onClick={toggleMobileMenu}
            aria-label={
              isMobileMenuOpen
                ? "Close navigation menu"
                : "Open navigation menu"
            }
            aria-expanded={isMobileMenuOpen}
            tabIndex={0}
          >
            {isMobileMenuOpen ? "✕" : "☰"}
          </MobileMenuButton>
        </HeaderContent>
      </HeaderWrapper>

      <MobileMenu
        isOpen={isMobileMenuOpen}
        role="navigation"
        aria-label="Mobile navigation menu"
      >
        <MobileNavLink
          href="#home"
          isActive={activeSection === "home"}
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("home");
          }}
          aria-label="Navigate to Home section"
          tabIndex={0}
        >
          Home
        </MobileNavLink>
        <MobileNavLink
          href="#about"
          isActive={activeSection === "about"}
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("about");
          }}
          aria-label="Navigate to About section"
          tabIndex={0}
        >
          About Me
        </MobileNavLink>
        <MobileNavLink
          href="#experience"
          isActive={activeSection === "experience"}
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("experience");
          }}
          aria-label="Navigate to Experience section"
          tabIndex={0}
        >
          Experience
        </MobileNavLink>
        <MobileNavLink
          href="#projects"
          isActive={activeSection === "projects"}
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("projects");
          }}
          aria-label="Navigate to Projects section"
          tabIndex={0}
        >
          Projects
        </MobileNavLink>
        <MobileNavLink
          href="#contact"
          isActive={activeSection === "contact"}
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("contact");
          }}
          aria-label="Navigate to Contact section"
          tabIndex={0}
        >
          Contact
        </MobileNavLink>
        <MobileDownloadButton
          onClick={handleDownloadResume}
          aria-label="Download Manoj Kumar's resume"
          tabIndex={0}
        >
          Download Resume
        </MobileDownloadButton>
      </MobileMenu>
    </>
  );
};

export default Header;
